import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from 'src/environments/environment';

export const featureToggleGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const featureKey = route.routeConfig?.path ?? '';

  let isRouteEnabled = false;

  if (Object.prototype.hasOwnProperty.call(environment.routes, featureKey)) {
    isRouteEnabled = (environment.routes as any)[featureKey];
  };

  return isRouteEnabled ? true : router.createUrlTree(['']);
};
